import Form from './Form';
import FormItem from './FormItem';

(Form as any).Item = FormItem;

export default Form;
